<template>
<div class="skipDetailList">
  <template v-if="list.length>0">
  <van-list v-model="isLoading" :finished='isFinish' @load='onLoad' :offset='70' :finished-text="finishText">
      <template v-for="(item,i) in list">
        <p class="title flex-between" >{{item.date}}<span class="gray">跳绳{{item.skipCount}}次</span></p>
        <div class="con" v-for="(row,k) in item.skipList" :key='i+"-"+k'>
            <p class="txt flex-between">{{row.typeName}}<span>{{row.createdTime}}</span></p>
            <div class="flex-between">
              <p><span class='bold'>{{row.skipNum}}</span><br><span class="gray">数量（个）</span></p>
              <p><span class='bold'>{{row.skipAvgNums}}</span><br><span class="gray">速率（个/分钟）</span></p>
              <p><span class='bold'>{{row.skipTimes	}}</span><br><span class="gray">时长（分钟）</span></p>
            </div>
        </div>
        <!-- <div class="con" v-if="item.classMode" >
            <p class="txt">随堂练习</p>
            <div class="flex-between">
              <p><span class='bold'>{{item.classMode.skipNum}}</span><br><span class="gray">数量（个）</span></p>
              <p><span class='bold'>{{item.classMode.skipAvgNums}}</span><br><span class="gray">速率（个/分钟）</span></p>
              <p><span class='bold'>{{item.classMode.skipTimes	}}</span><br><span class="gray">时长（分钟）</span></p>
            </div>
        </div> -->
        
      </template>
  </van-list>
  </template>
  <div class='noData' v-if="text">
    <div><img :src='require("@/assets/img/nodata.png")'><br />{{text}}</div>
  </div>
</div>
</template>
<script>
import {pageListSkipByCondition} from "@/api/api.report";
  export default {
    data() {
      return {
        list:[],
        pageNo:1,
        pageSize:7,
        isLoading:false,
        isFinish:true,
        finishText:'',
        total:0,
        text:'',
      }
    },
    created(){
     this.getList();
     
    },
    methods: {
      getList(){
         pageListSkipByCondition({
              studentId:this.loginUser.studentId,
              pageNo:this.pageNo,
              pageSize:this.pageSize
           }).then((data) => {
                 if(data.result&&data.result.list&&data.result.list.length>0){
                      data.result.list.forEach(item=>{
                         let time=item.date.split('-');
                         if(parseInt(time[1])<10){
                           time[1]=time[1].slice(1);
                         }
                         item.date=time[1]+'月'+time[2]+'日';
                         item.skipList.forEach(row=>{
                             let arr=row.createdTime.split(':');
                             row.createdTime=arr[0]+':'+arr[1];
                         })
                      })
                        this.list=this.list.concat(data.result.list);
                  }
                  this.isLoading=false;
                  this.total=data.result.totalNum;
                  if(data.result.totalNum==0){
                        this.text='暂无数据';
                  }else{
                        if(this.total==this.list.length){
                          this.isFinish=true;
                          this.finishText='-- 没有更多了 --';
                        }else{
                          this.isFinish=false;
                        }
                        
                  }
                 
           })
      },
      onLoad(){
         if(this.isFinish) return
         this.pageNo++;
         this.getList();
       }
    },
  }
</script>
<style lang="scss" >
.skipDetailList{
  padding:0rem .2rem .2rem;
    .title{
      color: #333;
      font-size: .14rem;
      padding-top: .26rem;
    }
    .gray{
            font-size: .12rem;
      }
    .con{
      margin-top: .13rem;
      background:#fff;
      border-radius: 12px;
      padding: .2rem .26rem;
      text-align: center;
       .txt{
          margin-bottom: .2rem;
          text-align: left;
        }
        .bold{
          font-weight: 600;
          font-size: .18rem;
          color:#333;
          margin-bottom: .1rem;
        }
    }
   
}
</style>